<template>
  <div class="relative">
    <div class="absolute inset-0 grid bg-white bg-opacity-50 place-items-center" v-show="uploading">
      <Loading />
    </div>
    <input type="file" class="absolute inset-0 z-50 opacity-0 cursor-pointer" @input="loadImage">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',

  props: {
    bucket: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      uploading: false,
      image: ''
    }
  },

  methods: {
    loadImage (event) {
      const files = event.target.files || event.dataTransfer.files
      this.image = files[0]
    },

    async uploadImage () {
      try {
        this.uploading = true
        const formData = new FormData()
        formData.append('image', this.image)
        formData.append('bucket', this.bucket)
        const { data } = await this.$api.post(`uploads/images`, formData)
        console.log(data)
        this.$emit('uploaded', data.Location)
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.uploading = false
      }
    }
  },

  watch: {
    image () {
      if (this.uploading) {
        return
      } else {
        this.uploadImage()
      }
    }
  }
}
</script>